import React from 'react';
import { FieldError, Controller } from 'react-hook-form';

type RadioOption = {
  id: string;
  label: string;
};

const RadioInput: React.FC<{
  id: string;
  control: any;
  options: RadioOption[];
  error?: FieldError;
}> = ({ id, control, options, error }) => {
  const errorComponent = error?.message && (
    <p className="italic font-main text-body-sm text-danger-600 mt-1">{error.message}</p>
  );

  return (
    <div className="inline-block relative w-full">
      <div className="inline-block relative w-full">
        {options.map((opt: RadioOption) => (
          <div key={opt.id} className="flex flex-row items-center my-1">
            <Controller
              control={control}
              name={id}
              render={({ field }) => (
                <input
                  className="h-5 w-5 rounded-full border-2 border-solid border-neutral-300 text-primary-600 focus:ring-2 focus:ring-primary-500 transition-colors cursor-pointer"
                  type="radio"
                  id={id}
                  checked={field.value === opt.id}
                  onChange={() => {
                    field.onChange(opt.id);
                  }}
                />
              )}
            />

            <label className="hover:cursor-pointer ml-2 text-neutral-900 text-body" htmlFor={opt.id}>
              {opt.label}
            </label>
          </div>
        ))}
      </div>
      {errorComponent}
    </div>
  );
};

export default RadioInput;
